import React from 'react';
import ReactDOM from 'react-dom';
import objectFitImages from 'object-fit-images';
import './index.css';
import 'normalize.css/normalize.css';
import AppRouter from './AppRouter';
import { unregister } from './registerServiceWorker';

objectFitImages(null, { watchMQ: true, });

ReactDOM.render(<AppRouter />, document.getElementById('root'));
unregister();
